import config from 'client/shared/config';

export default {
	Auth: {
		Cognito: {
			userPoolId: config.cognito.userPoolId,
			userPoolClientId: config.cognito.userPoolClientId,
			loginWith: {
				email: true,
				username: true
			}
		},
		authenticationFlowType: 'USER_PASSWORD_AUTH'
	}
};